import { HazardData } from '../data/platesData';
import common from './commonService';

interface Point {
  x: number;
  y: number;
}

export class HazardService {


    /**
     * standard constructor
     */
    constructor() {
        common.notifier$.subscribe(msg => {
            switch(msg.name) {

            }
        })
    }

    /**
     * standard initializer
     */
    async initialize() {
        try {

        } catch (ex) {
            console.error('failed to initialize diamonds:', ex);
        }
    }

    /**
     * get app data from native data
     * @param n 
     * @returns 
     */
    getHazardFromNative(n:any) {
      try {
        const h = new HazardData();
        Object.assign(h, n);
        h.rect = [...n.rect];
        return h;
      } catch (ex) {
        console.error('failed to get hazrd from native:', ex);
      }
    }

    /**
     * get app data from native data
     * @param nativeRecord 
     * @returns 
     */
    getHazardsFromNative(nativeRecord:any) {
        try {
          let natives = nativeRecord?.image_library?.human?.hazardous?.Annotations || [];
          const hazards = natives.map((n:any) => this.getHazardFromNative(n));
          return hazards;
        } catch (ex) {
          console.error('failed to get lights from native:', ex);
          return [];
        }
      }

      /**
       * native hazard item
       * @param h 
       * @returns 
       */
      getNativeHazard(h:HazardData) {
        try {
          return {rect: h.rect, id:h.id, class:h.class, text:h.text, un: h.un, ExtraType: h.ExtraType};
        } catch (ex) {
          console.error('failed to get native hazard:', ex);
        }
      }

      /**
       *  native hazard data
       * @param hazards 
       * @returns 
       */
      getNativeHazards(hazards: HazardData[]) {
        try {
          return hazards.map(h => this.getNativeHazard(h));
        } catch (ex) {
          console.error('failed to get native hazards:', ex);
        }
      }

      /**
       * data for tagging diff
       * @param original 
       * @returns 
       */
      getOriginalAndCurrent(original:any) {
        try {
          const previous = original?.image_library?.human?.hazardous?.Annotations || [];
          // sanitize extra types
          for (let prev of previous) {
            prev.ExtraType = prev.ExtraType || 0;
          }
          const current = this.getNativeHazards(common.plates.hazards);
          return {previous, current};
        } catch (ex) {
          console.error('failed to get original and current');
          return {previous:null, current:null};
        }
      }

      /***
       * get a new hazard data based on specified rect
       */
      getHazardFromRect(rect: number[]) {
        try {
            const h = new HazardData();
            h.rect = [...rect];
            return h;
        } catch (ex) {
            console.error('failed to get light from rect:', ex);
        }
      }

      isHovering = (): boolean => {
        try {
          // WTT-434
          if (common.plates.newTagType !== 'Hazard')
            return false;

          const hazards = common.plates.hazards;
          for (let l of hazards) {
            if (l.hoverIndex > -1) return true;
        }
        return false;
        } catch (ex) {
          console.error('failed on vehicle hovering:', ex);
          return false;
        }
      }

      resetHoverIndex() {
        try {
          
          const hazards = common.plates.hazards || [];
          hazards.forEach(h => h.hoverIndex = -1);
        } catch (ex) {
          console.error('failed to reset hover index:', ex);
        }
      }

      getPointsEx(rect:number[] | null) {
        try {
          if (!rect || rect.length !== 4)
            return [];
    
            const l = rect[0];
            const t = rect[1];
            const w = rect[2];
            const h = rect[3];
            const top = {x:l+w/2, y:t};
            const right = {x:l+w, y:t+h/2 };
            const bottom = {x:l+w/2,y:t+h};
            const left = {x:l,y:t+h/2};
            const pts =  [{x:l,y:t},{x:l+w,y:t},{x:l+w,y:t+h},{x:l,y:t+h},top, right, bottom, left];
            return pts;
        } catch (ex) {
          console.error("failed to get points: " + ex);
          return [];
        }
      }

      getDistance = (pt0:Point, pt1: Point) => {
        try {
          const dx = pt0.x - pt1.x;
          const dy = pt0.y - pt1.y;
          return Math.sqrt(dx*dx + dy*dy);
        } catch (ex) {
          console.error('failed to get point: ', ex);
          return 0;
        }
      };


      updateHoverIndex(ptMouse:any, radius: number) {
        try {
          this.resetHoverIndex();

          if (common.plates.newTagType !== 'Hazard')
            return false;

          // only selected light can be resized
          const selectedHazard = common.plates.selectedHazard;
          if (!selectedHazard)
            return false;

            const pts2 = this.getPointsEx(selectedHazard.rect);
            selectedHazard.hoverIndex = pts2?.findIndex(pt => this.getDistance(pt, ptMouse) < radius);
            if (selectedHazard.hoverIndex > -1)
              return true;
        } catch (ex) {
          console.error('failed to update hover index:', ex);
          return false;
        }
      }

      resizeRect(r:number[], hoverIndex:number, pt:any) {
        try {
          if (hoverIndex < 0) 
            return;

          const right = r[0] + r[2];
          const bottom = r[1] + r[3];
          let rect:number[] = [0,0,0,0];
          switch(hoverIndex) {
            case 0:
              rect = [pt.x, pt.y, right - pt.x, bottom - pt.y];
              break;
    
            case 1:
              rect = [r[0], pt.y, pt.x - r[0], bottom - pt.y];
              break;
    
            case 2:
              rect = [r[0], r[1], pt.x - r[0], pt.y - r[1]];
              break;
    
            case 3:
              rect = [pt.x, r[1], right - pt.x, pt.y - r[1]];
              break;
    
              // mid top
            case 4:
              rect = [r[0], pt.y, r[2], bottom - pt.y];
              break;
    
              // mid right
            case 5:
              rect = [r[0], r[1], pt.x - r[0], r[3]];
              break;
    
              // mid bottom
            case 6:
              rect = [r[0], r[1], r[2], pt.y - r[1]];
              break;
    
            case 7:
              rect = [pt.x, r[1], right - pt.x, r[3]];
              break;
          }
          for (let i = 0; i < 4; i++)
            r[i] = rect[i];

            return true;
        } catch (ex) {
          console.error('failed to resize rect:', ex);
        }
      }

      handleResize = (pt: any) => {
        try {
          const hazards = common.plates.hazards || [];

          for (let l of hazards) {
            if (l.hoverIndex > -1) {
              this.resizeRect(l.rect, l.hoverIndex, pt);
            }
          }
        } catch (ex) {
          console.error('failed to handle resize:', ex);
        }
      }


}
const hazardService: HazardService = new HazardService();
export default hazardService;